import React from 'react';
export const Logo = ({
  className
}: {
  className?: string;
}) => {
  return <div className={`flex items-center ${className || ''}`} data-id="element-472">
      <span className="font-serif-display italic text-2xl sm:text-3xl tracking-tight text-[#c9a875] leading-none whitespace-nowrap" data-id="element-473">
        ScaleWithLending
      </span>
    </div>;
};